module.exports = __webpack_public_path__ + "img/resume.9cbd780c.jpg";